import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "./api";

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada. Inicia sesión.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const input =
    "w-full border border-[#B2967D]/50 px-4 py-3 bg-white text-black placeholder:text-[#B2967D] focus:outline-none focus:border-[#7D5A44] transition-colors font-light";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#7D5A44] px-6 font-poppins">
      <div className="w-full max-w-md bg-white p-10">
        <h1 className="text-2xl font-bold text-black">Nueva contraseña</h1>
        {!token ? (
          <p className="mt-4 text-sm font-light text-red-600">Token de recuperación no válido o ausente.</p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="reset-form">
            <input
              data-testid="reset-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Nueva contraseña"
              className={input}
              required
            />
            <input
              data-testid="reset-confirm"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Confirmar contraseña"
              className={input}
              required
            />
            <button
              data-testid="reset-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#7D5A44] text-white px-8 py-4 text-sm font-bold tracking-wide uppercase hover:bg-black transition-colors duration-300 disabled:opacity-60"
            >
              {loading ? "Guardando..." : "Restablecer contraseña"}
            </button>
          </form>
        )}
        <div className="mt-6">
          <Link to="/admin/login" className="text-sm font-light text-[#B2967D] hover:text-black">
            ← Volver al inicio de sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
